/* Bounded checkout UI guard, not server-side validation. No cart mutations. */
// Local candidate. No network or mutations; release owner supplies the new cent variant.
const ISLAND_PRICE_VERSION = 'ef-island-stono95-20260916-v1';
const ISLAND_VARIANTS = [42659957702738,42659957735506,42659957768274,42659957801042];
const ISLAND_DOLLAR_VARIANT = 42659957833810;
function usdCents(value) {
  if (!Number.isFinite(value) || value < 0) throw Error('Invalid amount');
  const cents = Math.round(value * 100);
  if (!Number.isSafeInteger(cents) || Math.abs(cents / 100 - value) > 0.0000001) throw Error('Amount needs whole cents');
  return cents;
}
function stono95Cents(sourceCents) {
  if (!Number.isSafeInteger(sourceCents) || sourceCents < 0 || !Number.isSafeInteger(sourceCents * 95)) throw Error('Invalid source cents');
  return Math.floor((sourceCents * 95 + 50) / 100);
}
function islandCartItems({entry,totalCents,configId,properties={},centVariantId=null}) {
  const baseCents=usdCents(entry.base), upgrade=totalCents-baseCents;
  if (!ISLAND_VARIANTS.includes(entry.variantId) || !Number.isSafeInteger(totalCents) || upgrade < 0 || !configId) throw Error('Configuration needs a price review');
  const whole=Math.floor(upgrade/100), remainder=upgrade%100;
  if (remainder && (!Number.isSafeInteger(centVariantId) || centVariantId===ISLAND_DOLLAR_VARIANT || ISLAND_VARIANTS.includes(centVariantId))) throw Error('Exact-cent ordering is not ready; request a quote');
  const common={_config_id:configId,_pricing_version:ISLAND_PRICE_VERSION,_island_total_cents:String(totalCents),_island_base_cents:String(baseCents)};
  const items=[{id:entry.variantId,quantity:1,properties:{...properties,...common}}];
  for(const [id,quantity,unit] of [[ISLAND_DOLLAR_VARIANT,whole,100],[centVariantId,remainder,1]]) {
    if(quantity)items.push({id,quantity,properties:{...common,_parent_product:entry.title,_option_type:'Island configuration',_island_unit_cents:String(unit)}});
  }
  return items;
}
function assertIslandVariantPrices(items,variants) {
  for(const item of items){
    const expected=item.properties._parent_product?Number(item.properties._island_unit_cents):Number(item.properties._island_base_cents);
    const found=variants.find(v=>Number(v.id)===item.id);
    if(!found || found.available===false || found.price!==expected)throw Error('The current store price changed. Review this island before ordering');
  }
}
function auditIslandCart(cart,{centVariantId=null}={}) {
  const issues=[],items=cart.items||[], main=items.filter(i=>ISLAND_VARIANTS.includes(Number(i.variant_id)));
  for(const parent of main){
    const p=parent.properties||{},cfg=p._config_id;
    if(!cfg||p._pricing_version!==ISLAND_PRICE_VERSION){issues.push({key:parent.key,reason:'legacy-island-needs-review'});continue;}
    const group=items.filter(i=>i.properties?._config_id===cfg);
    if(group.filter(i=>!i.properties?._parent_product).length!==1){issues.push({key:parent.key,reason:'ambiguous-group'});continue;}
    const total=Number(p._island_total_cents),base=Number(p._island_base_cents),qty=parent.quantity;
    if(!Number.isSafeInteger(total)||!Number.isSafeInteger(base)||total<base||!Number.isSafeInteger(qty)||qty<1){issues.push({key:parent.key,reason:'invalid-price-contract'});continue;}
    let exact;
    try{exact=islandCartItems({entry:{variantId:Number(parent.variant_id),base:base/100,title:'Island'},totalCents:total,configId:cfg,centVariantId});}catch{issues.push({key:parent.key,reason:'unrepresentable-price'});continue;}
    let valid=group.length===exact.length;
    for(const target of exact){
      const actual=group.filter(i=>Number(i.variant_id)===target.id);
      const unit=target.properties._parent_product?Number(target.properties._island_unit_cents):base;
      valid=valid&&actual.length===1&&actual[0].quantity===target.quantity*qty&&actual[0].original_line_price===unit*target.quantity*qty&&actual[0].properties?._pricing_version===ISLAND_PRICE_VERSION;
    }
    const sum=group.reduce((n,i)=>n+i.original_line_price,0);
    if(!valid||sum!==total*qty)issues.push({key:parent.key,reason:'configured-price-mismatch'});
  }
  for(const child of items){
    if(![ISLAND_DOLLAR_VARIANT,centVariantId].includes(Number(child.variant_id)))continue;
    const cfg=child.properties?._config_id;
    if(!cfg||!main.some(p=>p.properties?._config_id===cfg))issues.push({key:child.key,reason:'orphan-island-upgrade'});
  }
  return {ok:issues.length===0,issues};
}

(function(){
  const script=document.currentScript;
  const CENT_VARIANT_ID=Number(script?.dataset.centVariant)||null;
  document.documentElement.classList.toggle('ef-island-cart-present',script?.dataset.islandInitial==='true');
  function syncIslandContext(event){
    const cart=event.detail?.cart||event.detail;
    if(!Array.isArray(cart?.items))return;
    document.documentElement.classList.toggle('ef-island-cart-present',cart.items.some(item=>ISLAND_VARIANTS.includes(Number(item.variant_id))||[ISLAND_DOLLAR_VARIANT,CENT_VARIANT_ID].includes(Number(item.variant_id))));
  }
  document.addEventListener('cart:refresh',syncIslandContext);
  document.addEventListener('cart:change',syncIslandContext);
  let checking=false;
  function show(message){
    let box=document.getElementById('ef-island-cart-review');
    if(!box){box=document.createElement('div');box.id='ef-island-cart-review';box.setAttribute('role','alert');box.style.cssText='position:fixed;z-index:2147483647;bottom:16px;left:16px;right:16px;background:#fff;color:#191919;padding:20px;border:1px solid #191919;box-shadow:0 3px 20px #0003';document.body.append(box);}
    box.textContent=message+' ';
    const close=document.createElement('button');close.type='button';close.textContent='Close';close.onclick=()=>box.remove();box.append(close);
  }
  async function check(event,continueAction){
    event.preventDefault();event.stopImmediatePropagation();
    if(checking)return;checking=true;
    try{
      const response=await fetch('/cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)throw Error('Cart unavailable');
      const result=auditIslandCart(await response.json(),{centVariantId:CENT_VARIANT_ID});
      if(!result.ok){show('Your island uses an earlier price or needs review. Open Edit build in your cart, confirm the current equipment and total, and add the reviewed build before checkout. If Edit build is unavailable, contact us at (949) 619-7824.');return;}
      continueAction();
    }catch(error){show('We could not verify your cart. Please try checkout again.');}
    finally{checking=false;}
  }
  document.addEventListener('click',event=>{
    const a=event.target.closest?.('a[href]');if(!a)return;
    const url=new URL(a.href,location.href);
    if(url.origin===location.origin&&/^\/checkout(?:\/|$)/.test(url.pathname))check(event,()=>location.assign(url.href));
  },true);
  document.addEventListener('submit',event=>{
    const form=event.target,submitter=event.submitter;
    if(!(form instanceof HTMLFormElement))return;
    const target=new URL(form.action,location.href);
    if(target.origin!==location.origin)return;
    if(/^\/checkout(?:\/|$)/.test(target.pathname)||(/^\/cart\/?$/.test(target.pathname)&&submitter?.name==='checkout')){
      check(event,()=>{if(submitter?.name){const input=document.createElement('input');input.type='hidden';input.name=submitter.name;input.value=submitter.value||'Checkout';form.append(input);}HTMLFormElement.prototype.submit.call(form);});
    }
  },true);
})();